// "Etsy'ye hazir mi" kontrol listesi — ortak kural seti (@erc/shared
// checkListingReadiness). Eksige tiklaninca ilgili bolume gidilir.

import { useState } from "react";
import { AlertTriangle, CheckCircle2, ChevronDown, ChevronUp, XCircle } from "lucide-react";
import type { ReadinessResult, ReadinessSection } from "@erc/shared";

export function ReadinessPanel({ result, onGo, defaultOpen }: {
  result: ReadinessResult;
  onGo: (section: ReadinessSection) => void;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen ?? !result.ready);
  const { blockers, warnings } = result;
  const tone = blockers.length ? "border-red-200 bg-red-50/60" : warnings.length ? "border-amber-200 bg-amber-50/60" : "border-emerald-200 bg-emerald-50/60";

  return (
    <div className={`rounded-xl border ${tone}`}>
      <button onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between px-4 py-2.5 text-left">
        <span className="flex items-center gap-2 text-sm font-semibold">
          {blockers.length ? (
            <><XCircle className="h-4 w-4 text-red-500" /><span className="text-red-700">Etsy'ye hazır değil — {blockers.length} eksik</span></>
          ) : (
            <><CheckCircle2 className="h-4 w-4 text-emerald-600" /><span className="text-emerald-700">Etsy'ye yüklemeye hazır</span></>
          )}
          {warnings.length > 0 && <span className="text-xs font-normal text-amber-700">· {warnings.length} öneri</span>}
        </span>
        {(blockers.length > 0 || warnings.length > 0) && (open ? <ChevronUp className="h-4 w-4 text-gray-400" /> : <ChevronDown className="h-4 w-4 text-gray-400" />)}
      </button>
      {open && (blockers.length > 0 || warnings.length > 0) && (
        <ul className="space-y-1 border-t border-black/5 px-4 py-2.5 text-xs">
          {blockers.map((b) => (
            <li key={b.code + b.message}>
              <button onClick={() => onGo(b.section)} className="flex items-start gap-1.5 text-left text-red-700 hover:underline">
                <XCircle className="mt-0.5 h-3 w-3 shrink-0" />{b.message}
              </button>
            </li>
          ))}
          {warnings.map((w) => (
            <li key={w.code + w.message}>
              <button onClick={() => onGo(w.section)} className="flex items-start gap-1.5 text-left text-amber-700 hover:underline">
                <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />{w.message}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
